// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelFormBody-ChannelType_cls1__zdiL1","cls2":"PaymentChannelFormBody-ChannelType_cls2__UaKf2 PaymentChannelFormBody-ChannelType_cls1__zdiL1"};